import React from 'react'

export const NoPage = () => {

  document.title = 'Juanlu / No page';

  return (
    <div>NoPage</div>
  )
}

export default NoPage;
